import { Check, X, Minus } from 'lucide-react';
import type { ModerationChoice } from '@/hooks/use-page-moderation';
import { cn } from '@repo/ui/lib/utils';

export const ModerationChoices = ({
  value,
  disabled,
  onChange,
}: {
  value: ModerationChoice;
  disabled: boolean;
  onChange: (choice: ModerationChoice) => void;
}) => (
  <div
    className="grid w-full grid-cols-3 divide-x divide-zinc-200 overflow-hidden rounded-lg border border-zinc-200 bg-zinc-50"
    role="group"
    aria-label="Moderation decision"
  >
    {(
      [
        ['approved', 'Approve', Check, 'bg-green-100 text-green-800'],
        ['rejected', 'Reject', X, 'bg-red-100 text-red-800'],
        ['ignore', 'Ignore', Minus, 'bg-zinc-200 text-zinc-900'],
      ] as const
    ).map(([choice, label, Icon, activeClass]) => (
      <button
        key={choice}
        type="button"
        disabled={disabled}
        aria-pressed={value === choice}
        onClick={() => onChange(choice)}
        className={cn(
          'flex min-h-14 min-w-0 flex-col items-center justify-center gap-1 px-1 py-2 text-xs font-medium transition-colors duration-150 motion-reduce:transition-none focus-visible:z-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-zinc-900 focus-visible:outline-offset-[-2px] disabled:pointer-events-none disabled:opacity-50',
          value === choice
            ? activeClass
            : 'text-zinc-500 hover:bg-zinc-100 hover:text-zinc-900',
        )}
      >
        <Icon
          aria-hidden="true"
          className="h-4 w-4"
          strokeWidth={value === choice ? 2.5 : 1.75}
        />
        <span>{label}</span>
      </button>
    ))}
  </div>
);
